import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#8B4513', // Darker saddle brown for navbar
      light: '#A0522D',
      dark: '#6B3811',
    },
    background: {
      default: '#F5F5F0', // Dirty white for page background
      paper: '#FFFFFF',    // Keep cards white
    },
    text: {
      primary: '#2C1810', // Warm brown
      secondary: '#5C4033', // Lighter brown
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h1: { fontFamily: 'Poppins' },
    h2: { fontFamily: 'Poppins' },
    h3: { fontFamily: 'Poppins' },
    h4: { fontFamily: 'Poppins' },
    h5: { fontFamily: 'Poppins' },
    h6: { fontFamily: 'Poppins' },
    subtitle1: { fontFamily: 'Poppins' },
    subtitle2: { fontFamily: 'Poppins' },
    body1: { fontFamily: 'Poppins' },
    body2: { fontFamily: 'Poppins' },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7))',
          boxShadow: '0 2px 4px rgba(44, 24, 16, 0.08)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          borderRadius: 12,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#8B4513', // Match primary.main
          boxShadow: '0 2px 4px rgba(44, 24, 16, 0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            fontFamily: 'Quicksand, sans-serif',
          },
        },
      },
    },
  },
}); 